import { createRouter, createWebHistory } from 'vue-router'

// We lazy load the components to improve performance, especially around the initial load
const SessionNew = () => import('./pages/sessions/new/index.vue')
const PasswordResetNew = () => import('./pages/password_resets/new/index.vue')
const PasswordsEdit = () => import('./pages/passwords/edit/index.vue')
const AdminApiClientsIndex = () => import('./pages/admin/api_clients/index/index.vue')
const AdminApiClientsNew = () => import('./pages/admin/api_clients/new/index.vue')
const AdminApiClientsEdit = () => import('./pages/admin/api_clients/edit/index.vue')
const AdminExportFormatsIndex = () => import('./pages/admin/export_formats/index/index.vue')
const AdminExportFormatsNew = () => import('./pages/admin/export_formats/new/index.vue')
const AdminExportFormatsEdit = () => import('./pages/admin/export_formats/edit/index.vue')
const AdminPublicationsIndex = () => import('./pages/admin/publications/index/index.vue')
const AdminPublicationsShow = () => import('./pages/admin/publications/show/index.vue')
const AdminPublicationsNew = () => import('./pages/admin/publications/new/index.vue')
const AdminPublicationsEdit = () => import('./pages/admin/publications/edit/index.vue')
const AdminSectionsIndex = () => import('./pages/admin/sections/index/index.vue')
const AdminSectionsNew = () => import('./pages/admin/sections/new/index.vue')
const AdminSectionsEdit = () => import('./pages/admin/sections/edit/index.vue')
const AdminSqueueIndex = () => import('./pages/admin/squeues/index/index.vue')
const AdminSqueueNew = () => import('./pages/admin/squeues/new/index.vue')
const AdminSqueueEdit = () => import('./pages/admin/squeues/edit/index.vue')
const AdminStyleMapIndex = () => import('./pages/admin/style_maps/index.vue')
const AdminStyleMapEdit = () => import('./pages/admin/style_maps/edit.vue')
const AdminTransformIndex = () => import('./pages/admin/transforms/index/index.vue')
const AdminTransformNew = () => import('./pages/admin/transforms/new/index.vue')
const AdminTransformEdit = () => import('./pages/admin/transforms/edit/index.vue')
const AdminUsersIndex = () => import('./pages/admin/users/index/index.vue')
const AdminUsersShow = () => import('./pages/admin/users/show/index.vue')
const AdminUsersNew = () => import('./pages/admin/users/new/index.vue')
const AdminUsersEdit = () => import('./pages/admin/users/edit/index.vue')
const DevLockedStoriesIndex = () => import('./pages/dev/locked_stories/index.vue')
const AdminConfigurationEdit = () => import('./pages/admin/configurations/edit/index.vue')
const AdminWebCategoriesIndex = () => import('./pages/admin/web_categories/index/index.vue')
const AdminWebCategoriesNew = () => import('./pages/admin/web_categories/new/index.vue')
const AdminWebCategoriesEdit = () => import('./pages/admin/web_categories/edit/index.vue')
const IssuesIndex = () => import('./pages/issues/index/index.vue')
const IssueShow = () => import('./pages/issues/show/index.vue')
const IssueNew = () => import('./pages/issues/new/index.vue')
const IssueClone = () => import('./pages/issues/clone/index.vue')
const IssueEdit = () => import('./pages/issues/edit/index.vue')
const MediaIndex = () => import('./pages/media/index/index.vue')
const PageShow = () => import('./pages/pages/show/index.vue')
const StoriesIndex = () => import('./pages/stories/index/index.vue')
const StoryForm = () => import('./components/stories/form/story_form.vue')
const StorySavedSearches = () => import('./pages/story_saved_searches/index.vue')
const StoryShow = () => import('./pages/stories/show/index.vue')
const LocationsIndex = () => import('./pages/locations/index/index.vue')
const LocationsNew = () => import('./pages/locations/new/index.vue')
const LocationsEdit = () => import('./pages/locations/edit/index.vue')
const LocationsShow = () => import('./pages/locations/show/index.vue')
const UserEdit = () => import('./pages/user/edit/index.vue')

const routes = [
  {
    path: '/session/new',
    name: 'newSession',
    component: SessionNew
  },
  {
    path: '/password_reset/new',
    name: 'newPasswordReset',
    component: PasswordResetNew
  },
  {
    path: '/passwords/:token/edit',
    name: 'editPassword',
    component: PasswordsEdit,
    props: ({ params: { token } }) => ({ token })
  },
  {
    path: '/admin/export_formats',
    name: 'adminExportFormats',
    component: AdminExportFormatsIndex
  },
  {
    path: '/admin/export_formats/new',
    name: 'newAdminExportFormat',
    component: AdminExportFormatsNew
  },
  {
    path: '/admin/export_formats/:exportFormatId/edit',
    name: 'editAdminExportFormat',
    component: AdminExportFormatsEdit,
    props: ({ params: { exportFormatId } }) => ({ exportFormatId: Number(exportFormatId) })
  },
  {
    path: '/admin/api_clients',
    name: 'adminApiClients',
    component: AdminApiClientsIndex
  },
  {
    path: '/admin/api_clients/new',
    name: 'newAdminApiClients',
    component: AdminApiClientsNew
  },
  {
    path: '/admin/api_clients/:apiClientId/edit',
    name: 'editAdminApiClients',
    component: AdminApiClientsEdit,
    props: ({ params: { apiClientId } }) => ({ apiClientId: Number(apiClientId) })
  },
  {
    path: '/admin/publications',
    name: 'adminPublications',
    component: AdminPublicationsIndex
  },
  {
    path: '/admin/publications/new',
    name: 'newAdminPublications',
    component: AdminPublicationsNew
  },
  {
    path: '/admin/publications/:publicationId/edit',
    name: 'editAdminPublication',
    component: AdminPublicationsEdit,
    props: ({ params: { publicationId } }) => ({ publicationId: Number(publicationId) })
  },
  {
    path: '/admin/publications/:publicationId',
    name: 'adminPublication',
    component: AdminPublicationsShow,
    props: ({ params: { publicationId } }) => ({ publicationId: Number(publicationId) })
  },
  {
    path: '/admin/sections',
    name: 'adminSections',
    component: AdminSectionsIndex
  },
  {
    path: '/admin/sections/new',
    name: 'newAdminSection',
    component: AdminSectionsNew
  },
  {
    path: '/admin/sections/:sectionId/edit',
    name: 'editAdminSection',
    component: AdminSectionsEdit,
    props: ({ params: { sectionId } }) => ({ sectionId: Number(sectionId) })
  },
  {
    path: '/admin/squeues',
    name: 'adminSqueues',
    component: AdminSqueueIndex
  },
  {
    path: '/admin/squeues/new',
    name: 'newAdminSqueues',
    component: AdminSqueueNew
  },
  {
    path: '/admin/squeues/:squeueId/edit',
    name: 'editAdminSqueues',
    component: AdminSqueueEdit,
    props: ({ params: { squeueId } }) => ({ squeueId: Number(squeueId) })
  },
  {
    path: '/admin/style_maps',
    name: 'adminStyleMaps',
    component: AdminStyleMapIndex
  },
  {
    path: '/admin/style_maps/:styleMapId/edit',
    name: 'editAdminStyleMap',
    component: AdminStyleMapEdit,
    props: ({ params: { styleMapId } }) => ({ styleMapId: Number(styleMapId) })
  },
  {
    path: '/admin/transforms',
    name: 'adminTransforms',
    component: AdminTransformIndex
  },
  {
    path: '/admin/transforms/new',
    name: 'newAdminTransform',
    component: AdminTransformNew
  },
  {
    path: '/admin/transforms/:transformId/edit',
    name: 'editAdminTransform',
    component: AdminTransformEdit,
    props: ({ params: { transformId } }) => ({ transformId: Number(transformId) })
  },
  {
    path: '/admin/users',
    name: 'adminUsers',
    component: AdminUsersIndex
  },
  {
    path: '/admin/users/new',
    name: 'newAdminUser',
    component: AdminUsersNew
  },
  {
    path: '/admin/users/:userId/edit',
    name: 'editAdminUser',
    component: AdminUsersEdit,
    props: ({ params: { userId } }) => ({ userId: Number(userId) })
  },
  {
    path: '/admin/users/:userId',
    name: 'adminUser',
    component: AdminUsersShow,
    props: ({ params: { userId } }) => ({ userId: Number(userId) })
  },
  {
    path: '/dev/locked_stories',
    name: 'devLockedStories',
    component: DevLockedStoriesIndex
  },
  {
    path: '/admin/configuration/edit',
    name: 'editAdminConfiguration',
    component: AdminConfigurationEdit
  },
  {
    path: '/admin/web_categories',
    name: 'adminWebCategories',
    component: AdminWebCategoriesIndex
  },
  {
    path: '/admin/web_categories/new',
    name: 'newAdminWebCategory',
    component: AdminWebCategoriesNew
  },
  {
    path: '/admin/web_categories/:webCategoryId/edit',
    name: 'editAdminWebCategory',
    component: AdminWebCategoriesEdit,
    props: ({ params: { webCategoryId } }) => ({ webCategoryId: Number(webCategoryId) })
  },
  {
    path: '/issues/new',
    name: 'newIssue',
    component: IssueNew
  },
  {
    path: '/issues/:issueId/clone',
    name: 'cloneIssue',
    component: IssueClone,
    props: ({ params: { issueId } }) => ({ issueId: Number(issueId) })
  },
  {
    path: '/issues/:issueId/edit',
    name: 'editIssue',
    component: IssueEdit,
    props: ({ params: { issueId } }) => ({ issueId: Number(issueId) })
  },
  {
    path: '/issues/:issueId',
    name: 'issue',
    component: IssueShow,
    props: ({ params: { issueId } }) => ({ issueId: Number(issueId) })
  },
  {
    path: '/issues/:issueId/pages/:pageId',
    name: 'issuePage',
    component: PageShow,
    props: ({ params: { issueId, pageId } }) => ({
      issueId: Number(issueId),
      pageId: Number(pageId)
    })
  },
  {
    path: '/issues',
    name: 'issues',
    component: IssuesIndex
  },
  {
    path: '/issues/:issueId/stories/:storyId/edit',
    name: 'editIssueStory',
    component: StoryForm,
    props: ({ params: { issueId, storyId } }) => ({
      issueId: Number(issueId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/issues/:issueId/stories/:storyId',
    name: 'issueStory',
    component: StoryShow,
    props: ({ params: { issueId, storyId } }) => ({
      issueId: Number(issueId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/issues/:issueId/pages/:pageId/stories/:storyId/edit',
    name: 'editPageStory',
    component: StoryForm,
    props: ({ params: { issueId, pageId, storyId } }) => ({
      issueId: Number(issueId),
      pageId: Number(pageId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/issues/:issueId/pages/:pageId/stories/:storyId',
    name: 'pageStory',
    component: StoryShow,
    props: ({ params: { issueId, storyId } }) => ({
      issueId: Number(issueId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/media',
    name: 'media',
    component: MediaIndex
  },
  {
    path: '/stories',
    name: 'stories',
    component: StoriesIndex
  },
  {
    path: '/stories/:storyId',
    name: 'story',
    component: StoryShow,
    props: ({ params: { storyId } }) => ({ storyId: Number(storyId) })
  },
  {
    path: '/stories/:storyId/edit',
    name: 'editStory',
    component: StoryForm,
    props: ({ params: { storyId } }) => ({ storyId: Number(storyId) })
  },
  {
    path: '/story_saved_searches',
    name: 'storySavedSearches',
    component: StorySavedSearches,
  },
  {
    path: '/locations',
    name: 'locations',
    component: LocationsIndex
  },
  {
    path: '/locations/new',
    name: 'newLocation',
    component: LocationsNew
  },
  {
    path: '/locations/:locationId/edit',
    name: 'editLocation',
    component: LocationsEdit,
    props: ({ params: { locationId } }) => ({ locationId: Number(locationId) })
  },
  {
    path: '/locations/:locationId',
    name: 'showLocation',
    component: LocationsShow,
    props: ({ params: { locationId } }) => ({ locationId: Number(locationId) })
  },
  {
    path: '/user/edit',
    name: 'editUser',
    component: UserEdit
  },
  {
    path: '/',
    component: StoriesIndex
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { el: to.hash }
    } else {
      return { top: 0 }
    }
  }
})

export default router
